import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';

import { AdminQuestionFormValues, IAdminQuestion } from '../models/AdminQuestion';

const LIMIT = 50;

export default class AdminQuestionStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.page = 0;
                this.AdminQuestionRegistry.clear();
                this.loadAdminQuestions();
            }
        )
    }

    AdminQuestionRegistry = new Map();
    AdminQuestion: IAdminQuestion | null = null;
    loadingInitial = false;
    submitting = false;
    target = "";

    AdminQuestionCount = 0;
    page = 0;

    predicate = new Map();

    setPredicate = (predicate: string, value: string | Date) => {
        this.predicate.clear();
        if (predicate !== 'My Notes') {
            this.predicate.set(predicate, value);
        } else {
            this.predicate.set('createdById', this.rootStore.userStore.user?.id)
        }
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(LIMIT));
        params.append('offset', `${this.page ? this.page * LIMIT : 0}`);
        this.predicate.forEach((value, key) => {
            if (key === 'dateCreated') {
                params.append(key, value.toDateString());
            } else {
                params.append(key, value);
            }
        })
        return params;
    }

    get totalPages() {
        return Math.ceil(this.AdminQuestionCount / LIMIT);
    }

    setPage = (page: number) => {
        this.page = page;
    }

    get AdminQuestionsById() {
        return Array.from(this.AdminQuestionRegistry.values()).sort(
            (a, b) => b.id - a.id
        );
    };

    loadAdminQuestions = async () => {
        this.loadingInitial = true;
        try {
            const AdminQuestionEnvelope = await agent.AdminQuestion.list(this.axiosParams);
            const { questionsDTO, questionCount } = AdminQuestionEnvelope;

            runInAction('loadAdminQuestion', () => {
                questionsDTO.forEach((questionDTO) => {
                    this.AdminQuestionRegistry.set(questionDTO.id, questionDTO);
                });
                this.AdminQuestionCount = questionCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadAdminQuestion', () => {
            this.loadingInitial = false;
        });
    };

    getAdminQuestion = (id: string) => {
        return this.AdminQuestionRegistry.get(id);
    }

    getAdminQuestionDropdown = () => {
        var adminQuestions: IAdminQuestion[] = Array.from(this.AdminQuestionRegistry.values());

        var SelectedQuestionResults: {
            key: string;
            text: string;
            value: string;
        }[] = [];

        adminQuestions.forEach(element => {
            SelectedQuestionResults.push(
                {
                    key: element.id,
                    text: element.question,
                    value: element.id
                })
        });

        return SelectedQuestionResults;
    }

    ClearAdminQuestion = () => {
        this.AdminQuestion = null;
    }

    createAdminQuestion = async (adminQuestion: AdminQuestionFormValues) => {
        this.submitting = true;
        try {
            const newId = await agent.AdminQuestion.create(adminQuestion);
            await this.loadAdminQuestions();
            toast.success('Saved');
            runInAction('created Admin Question', () => {
                this.submitting = false;
                this.rootStore.modalStore.closeModal();
            });

        } catch (error) {
            runInAction('created Admin Question', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    editAdminQuestion = async (adminQuestion: AdminQuestionFormValues) => {

        this.submitting = true;
        try {
            await agent.AdminQuestion.update(adminQuestion);
            runInAction('editAdminQuestion', () => {
                this.submitting = false;
            });
            toast.success('Updated Admin Question');
            this.AdminQuestionRegistry.set(adminQuestion.id, adminQuestion);
            this.rootStore.modalStore.closeModal();
        } catch (error) {
            runInAction('editAdminQuestion', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };



}
decorate(AdminQuestionStore, {
    AdminQuestionRegistry: observable,
    AdminQuestion: observable,
    loadingInitial: observable,
    submitting: observable,
    target: observable,
    AdminQuestionCount: observable,
    page: observable,
    predicate: observable,

    loadAdminQuestions: action,
    ClearAdminQuestion: action,
    setPredicate: action,
    setPage: action,
    createAdminQuestion: action,
    editAdminQuestion: action,
    getAdminQuestionDropdown: action,

    AdminQuestionsById: computed,
    axiosParams: computed,
    totalPages: computed
});